import { render, staticRenderFns } from "./fee-pdf-card.vue?vue&type=template&id=c47c2656&scoped=true&"
import script from "./fee-pdf-card.vue?vue&type=script&lang=ts&"
export * from "./fee-pdf-card.vue?vue&type=script&lang=ts&"
import style0 from "./fee-pdf-card.vue?vue&type=style&index=0&id=c47c2656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47c2656",
  null
  
)

export default component.exports